<template>
  <div :class="[`grid grid-cols-2 gap-x-8`]">
    <div>
      <div v-for="plan in plans_displayed.slice(0, Math.ceil(plans_displayed.length / 2))" :key="plan.id">
        <PlanCard :plan="plan" />
      </div>
    </div>
    <div>
      <div v-for="plan in plans_displayed.slice(Math.round(plans_displayed.length / 2), plans_displayed.length)" :key="plan.id">
        <PlanCard :plan="plan" />
      </div>
    </div>
  </div>

  <div class="flex items-center w-full mt-10">
    <div v-if="plans_count > 6" class="mr-2 text-sm text-common-grey">
      {{ $t("Show") }}
    </div>
    <SelectInput
      v-if="plans_count > 6"
      :value="perPage"
      :is-box-background="true"
      class="w-[115px]"
      :input-classes="'text-left'"
      name="page_show_options"
      :allow-null="false"
      :items="page_show_options"
      @update:currentItem="perPage = $event" />
    <div v-if="plans_count > 6" class="ml-2 text-sm text-common-grey">
      {{ $t("in page") }}
    </div>
    <Pagination v-if="plans_count > perPage"
                class="ml-auto"
                :total-pages="total_pages"
                :current-page="currentPage"
                @input="changePage" />
  </div>
</template>

<script>
import Pagination from "@/components/shared/Pagination.vue"
import dataService from "@/services/data.service"
import PlanCard from "./PlanCard.vue"
import SelectInput from "@/components/shared/SelectInput.vue"
export default {
  components: { Pagination, PlanCard, SelectInput },
  props: {},
  emits: [],

  data() {
    return {
      plans_count: 0,
      plans_displayed: [],
      currentPage: 1,
      plans_status: null,
      search_term: "",
      plans_companies: [],
      plans_collaborators: [],
      plans_contacts: [],
      plans_due_date_range: null,
      total_pages: 1,
      perPage: 6
    }
  },
  computed: {
    page_show_options() {
      const options = [6]
      if (this.plans_count > 6) {
        options.push(8)
      }
      if (this.plans_count > 8) {
        options.push(10)
      }
      if (this.plans_count > 10) {
        options.push(12)
      }
      return options
    }
  },
  watch: {
    perPage: {
      handler() {
        this.getFilteredPlans(1)
      }
    }
  },

  created() {
    this.getFilteredPlans(1)
  },

  methods: {
    totalPages(plans) {
      this.total_pages = Math.ceil(parseInt(plans.count) / parseInt(this.perPage))
      this.plans_count = plans.count
    },

    getFilteredPlans(page) {
      let params = {
        page_size: this.perPage,
        page: page ? page : 1,
        expand: "record",
        ...(!!this.plans_collaborators && { collaborators: this.plans_collaborators.join(",") }),
        ...(!!this.plans_status && { status: this.plans_status.join(",") }),
        ...(!!this.plans_companies?.length && { record: this.plans_companies.map((c) => c.id).join(",") }),
        ...(!!this.plans_contacts && { contacts: this.plans_contacts.map((c) => c.id).join(",") })
      }
      // params["prevent_loading"] = true
      if (this.search_term) {
        params["name"] = this.search_term
      }
      if (this.plans_due_date_range) {
        params["due_date_start"] = this.$moment(this.plans_due_date_range.start).format("L")
        params["due_date_end"] = this.$moment(this.plans_due_date_range.end).format("L")
      }
      dataService.getPlans(params).then((res) => {
        this.totalPages(res.data)
        this.plans_displayed = res.data.results
      })
    },

    // resetFilters() {
    //   this.getFilteredPlans(1)
    //   this.plans_status = null
    //   this.search_term = ""
    //   this.plans_companies = []
    //   this.plans_collaborators = []
    //   this.plans_due_date_range = null
    //   this.currentPage = 1
    // },

    changePage(page) {
      this.currentPage = page
      this.getFilteredPlans(page)
    }
  }
}
</script>
